<template>
	<div class="row">
    <div class="col-md-12">

      <!-- <h4 v-if=" getCategory != 'infantil' ">{{ $t('Buscador Avanzado') + ' ' + categoryTitle }}</h4> -->

      <div class="row buscador-avanzado-csd">
        <div class="col-md-6">          
          <div class="form-head fix">

            <input-autocomplete
              :title="$t('Título')" 
              searchField="TITULO" 
              :searchCategory="searchCategory" :value.sync="frm.TITULO"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Título original')" 
              searchField="C_TITULO_ORIGINAL" 
              :searchCategory="searchCategory" :value.sync="frm.C_TITULO_ORIGINAL"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Director/a')" 
              searchField="C_DIRECTORES" 
              :searchCategory="searchCategory" :value.sync="frm.C_DIRECTORES"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Actor/Actriz')" 
              searchField="C_ACTORES" 
              :searchCategory="searchCategory" :value.sync="frm.C_ACTORES"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Guionista')" 
              searchField="C_GUIONISTAS" 
              :searchCategory="searchCategory" :value.sync="frm.C_GUIONISTAS"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Novelista')" 
              searchField="C_NOVELISTAS" 
              :searchCategory="searchCategory" :value.sync="frm.C_NOVELISTAS"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Temática')" 
              searchField="C_TEMATICA" 
              :searchCategory="searchCategory" :value.sync="frm.C_TEMATICA"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('País de producción')" 
              searchField="C_PAIS_PRODUCCION" 
              :searchCategory="searchCategory" :value.sync="frm.C_PAIS_PRODUCCION"
              :reset="reset">      
            </input-autocomplete>

            <input-autocomplete
              :title="$t('Distribuidora')" 
              searchField="EDITOR" 
              :searchCategory="searchCategory" :value.sync="frm.EDITOR"
              :reset="reset">      
            </input-autocomplete>

          </div>
        </div>

        <div class="col-md-6">
          <input-autocomplete
            :title="$t('Idioma')" 
            searchField="C_IDIOMAS" 
            :searchCategory="searchCategory" :value.sync="frm.C_IDIOMAS"
            :reset="reset">      
          </input-autocomplete>

          <div class="input-group">
            <div class="input-group-addon"><span>{{ $t('Año de producción') }}</span></div>
            <input type="number" class="form-control" :placeholder="$t('Año de producción')" maxlength="150" v-model="frm.C_ANO_PRODUCCION">
          </div>

          <custom-select-box 
            :title="$t('Género')" 
            searchField="C_GENERO" 
            :searchCategory="searchCategory" :value.sync="frm.C_GENERO"
            :reset="reset">
          </custom-select-box>  

          <custom-select-box 
            :title="$t('Forma')" 
            searchField="C_FORMATO" 
            :searchCategory="searchCategory" :value.sync="frm.C_FORMATO"
            :reset="reset">
          </custom-select-box>  

          <custom-select-box 
            :title="$t('Edad')" 
            searchField="C_CALIFICACION_EDAD" 
            :searchCategory="searchCategory" :value.sync="frm.C_CALIFICACION_EDAD"
            :reset="reset">
          </custom-select-box>        
          
          <custom-select-box 
            :title="$t('Formato')" 
            searchField="FORMATO" 
            :searchCategory="searchCategory" :value.sync="frm.FORMATO"
            :reset="reset">
          </custom-select-box>

          <div class="row">
            <div class="col-xs-6">
              <div class="input-group mr10">
                <div class="input-group-addon"><span>{{ $t('Precio min') }}</span></div>
                <input type="number" class="form-control" :placeholder="$t('Precio min')" maxlength="150" v-model="frm.PRECIO_MIN">
              </div>
            </div>
            <div class="col-xs-6">
              <div class="input-group">
                <div class="input-group-addon"><span>{{ $t('Precio max') }}</span></div>
                <input type="number" class="form-control" :placeholder="$t('Precio max')" maxlength="150" v-model="frm.PRECIO_MAX">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-6">
              <div class="input-group">
                <div class="input-group-addon"><span>{{ $t('Audiodescripción') }}</span></div>
                <input type="checkbox" value="S" v-model="frm.C_CIEGOS">
              </div>
            </div>
            <div class="col-xs-6">
              <div class="input-group">
                <div class="input-group-addon"><span>{{ $t('Cod. sordos') }}</span></div>
                <input type="checkbox" value="S" v-model="frm.C_SORDOS">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-6">
              <div class="input-group">
                <div class="input-group-addon"><span>{{ $t('Novedad') }}</span></div>
                <input type="checkbox" v-model="frm.NOVEDAD">
              </div>
            </div>
            <div class="col-xs-6">
              <div class="input-group">
                <div class="input-group-addon"><span>{{ $t('Recomendado') }}</span></div>
                <input type="checkbox" value="S" v-model="frm.RECOMENDADO">
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>

          <div class="center">
            <button class="btn btn-tata mb40" type="submit" @click="resetForm">{{ $t('Vaciar') }} <i class="fa fa-remove"></i></button>
            <button class="btn btn-tata mb40" type="submit" :disabled="loading" @click="submitSearch">{{ $t('Buscar') }} <i class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
    </div>  
  </div>
</template>

<i18n>
{
  "es": {
  	"Buscador Avanzado": "Buscador Avanzado",
    "Título": "Título",
    "Título original": "Título original",
    "Director/a": "Director/a",
    "Actor/Actriz": "Actor/Actriz",
    "Guionista": "Guionista",
    "Novelista": "Novelista",
    "Temática": "Temática",
    "País de producción": "País de producción",
    "Distribuidora": "Distribuidora",
    "Idioma": "Idioma",
    "Año de producción": "Año de producción",
    "Género": "Género",
    "Forma": "Forma",
    "Edad": "Edad",
    "Formato": "Formato",
    "Precio min": "Precio min",
    "Precio max": "Precio max",
    "Novedad": "Novedad",
    "Recomendado": "Recomendado",
    "Audiodescripción": "Audiodescripción",
    "Cod. sordos": "Cod. sordos",
    "Buscar": "Buscar",
    "Debe rellenar como mínimo un campo": "Debe rellenar como mínimo un campo",
    "Cine": "Cine", 
    "Series": "Series",
    "Documentales": "Documentales",
    "Indice": "Indice",
    "Vaciar": "Vaciar"
  },
  "en": {
  },
  "ca": {
    "Buscador Avanzado": "Cercador avançat",
    "Título": "Títol",
    "Título original": "Títol original",
    "Director/a": "Director/a",
    "Actor/Actriz": "Actor/Actriu",
    "Guionista": "Guionista",
    "Novelista": "Novel·lista",
    "Temática": "Temàtica",
    "País de producción": "País de producció",
    "Distribuidora": "Distribuïdora",
    "Idioma": "Idioma",
    "Año de producción": "Any de producció",
    "Género": "Gènere",
    "Forma": "Forma",
    "Edad": "Edat",
    "Formato": "Format",
    "Precio min": "Preu mín",
    "Precio max": "Preu màx",
    "Novedad": "Novetat",
    "Recomendado": "Recomanat",
    "Audiodescripción": "Audiodescripció",
    "Cod. sordos": "Cod. sords",
    "Buscar": "Buscar",
    "Debe rellenar como mínimo un campo": "Ha d'omplir com a mínim un camp",
    "Cine": "Cine", 
    "Series": "Sèries",
    "Documentales": "Documentals",
    "Indice": "Índex",
    "Vaciar": "Buidar"
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';
  import CustomSelectBox from './CustomSelectBox.vue';
  import InputAutocomplete from './InputAutocomplete.vue';

  export default {
    props: ['searchCategory'],
    components: { CustomSelectBox, InputAutocomplete },
    data: () => {
      return{
        loading: false,
        frm_error: false,
        frm_error_message: '',
        frm:{
          TITULO: '',
          C_TITULO_ORIGINAL: '',
          C_DIRECTORES: '',
          C_ACTORES: '',
          C_GUIONISTAS: '',
          C_NOVELISTAS: '',
          C_TEMATICA: '',
          C_PAIS_PRODUCCION: '',
          EDITOR: '',
          C_IDIOMAS: '',
          C_ANO_PRODUCCION: '',
          C_GENERO: '',
          C_FORMATO: '',
          C_CALIFICACION_EDAD: '',
          FORMATO: '',
          PRECIO_MIN: '',
          PRECIO_MAX: '',
          C_CIEGOS: false,
          C_SORDOS: false,
          NOVEDAD: false,
          RECOMENDADO: false,
          a_tipo: '',
        },
        reset: false,
      }
    },
    mounted(){
    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl', 'getCategory']), 
      categoryTitle: function(){
        switch(this.searchCategory){
          case('cine'): return this.$t('Cine'); break;
          case('series'): return this.$t('Series'); break;
          case('documentales'): return this.$t('Documentales'); break;
          default: return this.$t('Indice'); break;
        }
      }
    },
    methods: {
      submitSearch() {
        this.frm_error = false;

        if( this.searchData() ){

          //this.frm.a_tipo = (this.searchCategory) ? this.searchCategory.substr(0,1) : '';
          switch(this.searchCategory){
            case('cine'):         this.frm.a_tipo = 'c'; break;
            case('series'):       this.frm.a_tipo = 's'; break;
            case('documentales'): this.frm.a_tipo = 'd'; break;
            default:              this.frm.a_tipo = 'x'; break;
          }
          //console.log(this.searchCategory)
          //console.log(this.getCategory)
          //console.log(this.frm.a_tipo)
          
          this.frm.C_CIEGOS = (this.frm.C_CIEGOS == false) ? '' : true;
          this.frm.C_SORDOS = (this.frm.C_SORDOS == false) ? '' : true;
          this.frm.NOVEDAD = (this.frm.NOVEDAD == false) ? '' : true;
          this.frm.RECOMENDADO = (this.frm.RECOMENDADO == false) ? '' : true;

          // COPIAR VARIABLES RELLENADAS
          let dataToSend = {};
          for (var prop in this.frm) {
            if (this.frm.hasOwnProperty(prop)) {
              if( this.frm[prop] != '' ){
                dataToSend[prop] = this.frm[prop];
              }
            }
          }

          // Añadir ref para stats
          dataToSend['ref'] = 'buscador_avanzado';

          this.$router.push({ 
            name: 'buscador-avanzado', 
            params: { language: this.getLocale, category: this.getCategory },
            query: dataToSend
          })
          // this.frm_novelty 

        }else{
          this.frm_error_message = this.$t('Debe rellenar como mínimo un campo');
          this.frm_error = true;
        }
      },
      searchData(){
        for (var prop in this.frm) {
          if (this.frm.hasOwnProperty(prop)) {
            if( this.frm[prop] != '' && prop != 'a_tipo' ){
              return true;
            }
          }
        }
        return false;
      },
      resetForm(){
        this.reset = !this.reset;
        this.frm.C_ANO_PRODUCCION = this.frm.PRECIO_MIN = this.frm.PRECIO_MAX = '';
        this.frm.C_CIEGOS = this.frm.C_SORDOS = this.frm.NOVEDAD = this.frm.RECOMENDADO = false;
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
    watch:{
    }
  }
</script>
